import { Component, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OrderTrackingService } from './service/order-tracking.service';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe, JsonPipe, NgTemplateOutlet } from '@angular/common';
import { CorpCardComponent, CorpLoadingComponent } from '@corporate-tailwind/component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-order-tracking',
    imports: [TranslateModule, CorpCardComponent, DatePipe, CorpLoadingComponent, NgTemplateOutlet],
    templateUrl: './order-tracking.component.html',
    styleUrl: './order-tracking.component.scss'
})
export class OrderTrackingComponent implements OnDestroy {
formOrderTracking: FormGroup | null = null;

    constructor(

        public _orderTrackingService: OrderTrackingService,
        public _route: ActivatedRoute
        ) {       

            this._route.queryParams.subscribe(params => {
                const orderCode = params['orderCode'];
                if (orderCode) {                
                    this._orderTrackingService.load(orderCode);
                } 
            });
            this.formOrderTracking = this._orderTrackingService.formGroup;
    }

    ngOnDestroy(): void {
        console.log('OrderTrackingComponent--> !destroyed!');
        this._orderTrackingService.unload();
    }
    
}